import { Injectable } from '@angular/core';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { filter, tap, withLatestFrom, combineLatest, first, distinctUntilChanged } from 'rxjs/operators';
import { AthleteCategoriesCombo } from '../../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { BootstrapAthleteStatisticsComponent } from '../components/bootstrap-athlete-statistics/bootstrap-athlete-statistics.component';


@Injectable({
  providedIn: 'root'
})
export class FiltersAthleteWorldRankingsStatisticsService {

  /**
   * The common categories combo without team value.
   *
   * @type {AthleteCategoriesCombo}
   * @memberof FiltersAthleteWorldRankingsStatisticsService
   */
  categoryComboStats: AthleteCategoriesCombo = new AthleteCategoriesCombo('Categories: ', 'stats-combo', [], this.http, false);
  constructor(private common_service: FiltersAthleteGeneralService, private http: HttpClient) {
    this.common_service.storedId.pipe(
      filter(a => a != null),
      combineLatest(this.common_service.athleteDetailStore.dataStream.pipe(filter(value => value != null),
        distinctUntilChanged((f, s) => f[0].Id === s[0].Id)
      )),
      tap(([a, b]) => {
        const worldRankingData = (b[0].WorldRankings.Best).sort((f, s) => f.Rnk > s.Rnk ? 1 : -1);
        const comboData = b[0].AthleteCategories
          .filter(value => worldRankingData.findIndex(worldRankingCategory => value.Cat === worldRankingCategory.CatCode) > -1)
          .map((value, i) => { return { item: value, position: i } });
        this.categoryComboStats = new AthleteCategoriesCombo('Categories: ', 'stats-combo', comboData, http, false);
        // Select current if any, if not, the better from historic data.
        const worldRankingBestData = (b[0].WorldRankings.Current && b[0].WorldRankings.Current.length > 0 ?
          b[0].WorldRankings.Current :
          b[0].WorldRankings.Best).sort((f, s) => f.Rnk > s.Rnk ? 1 : -1);
        const categorySelected = comboData.find(value => value.item.Cat === worldRankingBestData[0].CatCode);
        // Se the default category with highest world ranking rank.
        setTimeout(()=>{
          this.categoryComboStats.filterInfo.options.options_selected_subject.next(categorySelected.item);
        }, 30)
      })

    ).subscribe();

  }

}
